import {Component, OnInit, OnDestroy} from '@angular/core';
import {SpinnerState, SpinnerService} from './spinner.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnDestroy {
  visible = true;
  private spinnerStateChanged: Subscription;

  constructor(private spinnerService: SpinnerService) { }
  ngOnInit() {
    this.spinnerStateChanged = this.spinnerService.getSpinnerState()
      .subscribe((state: SpinnerState) => this.visible = state.show);
    this.spinnerService.hide();
  }


  ngOnDestroy() {
    this.spinnerStateChanged.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/core/spinner/spinner.component.ts